<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="五育类型" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="五育评价指标库" name="second">
                <child2></child2>    
            </el-tab-pane>
            
            <el-tab-pane label="教职评价一级目录" name="ten">
                <child10></child10>    
            </el-tab-pane>

            <el-tab-pane label="班级评价一级目录" name="five">
                <child5></child5>    
            </el-tab-pane>

            <el-tab-pane label="评价二级目录" name="six">
                <child6></child6>    
            </el-tab-pane>
            
            <el-tab-pane label="学生评比设置" name="three">
                <child3></child3>    
            </el-tab-pane>

            <el-tab-pane label="班级评比设置" name="four">
                <child4></child4>    
            </el-tab-pane>

            <el-tab-pane label="班主任设置" name="seven">
                <child7></child7>    
            </el-tab-pane>

            <el-tab-pane label="五育评价审核人" name="eight">
                <child8></child8>    
            </el-tab-pane>
            
            <el-tab-pane label="评价评分人" name="nine">
                <child9></child9>    
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import EvaluateType from './EvaluateType.vue'
    import EvaluateIndicatorsDefine from './EvaluateIndicatorsDefine.vue'
    import StudentEvaluateConfig from './StudentEvaluateConfig.vue'
    import ClassEvaluateConfig from './ClassEvaluateConfig.vue'
    // 班级评价设置
    import ClassEvaluateType from '../classset/ClassEvaluateType.vue'
    import ClassEvaluateIndicatorsSet from '../classset/ClassEvaluateIndicatorsSet.vue'
    // 教职评价
    import TeacherEvaluateType from '../classset/TeacherEvaluateType.vue'
    // 班主任设置
    import classMaster from '../classmaster/classMaster.vue'
    // 一日常规审核人
    import evaluateCheckuserSet from '../checkUserSet/EvaluateCheckuserSet.vue'
    // 一日常规评价人
    import moduleConfig from './moduleConfig.vue'

    export default {
        name:"EvaluateTypeMain",
        components:{
            child1:EvaluateType,
            child2:EvaluateIndicatorsDefine,
            child3:StudentEvaluateConfig,
            child4:ClassEvaluateConfig,
            child5:ClassEvaluateType,
            child6:ClassEvaluateIndicatorsSet,
            child7:classMaster,
            child8:evaluateCheckuserSet,
            child9:moduleConfig,
            child10:TeacherEvaluateType,
        },
        data() {
            return {
                menuName:"",
                //默认第一个选项卡
                activeName: "first",
                title:"五育类型"
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="五育类型";
                }else if(tab.name == "second") {
                    this.title="五育评价指标库";
                }else if(tab.name == "three") {
                    this.title="学生评比设置";
                }else if(tab.name == "four") {
                    this.title="班级评比设置";
                }else if(tab.name == "five") {
                    this.title="班级评价一级目录";
                }else if(tab.name == "six") {
                    this.title="评价二级目录";
                }else if(tab.name == "seven") {
                    this.title="班主任设置";
                }else if(tab.name == "eight") {
                    this.title="五育评价审核人";
                }else if(tab.name == "nine") {
                    this.title="评价评分人";
                }else if(tab.name == "ten") {
                    this.title="教职评价一级目录";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateTypeMain.vue